// extracted by mini-css-extract-plugin
export default {"clock":"Clock_clock__xtjWm","piece":"Clock_piece__JkpkF"};